module.exports = __webpack_public_path__ + "img/Landing_book.a9cb6c79.svg";